/**
 * Tiny cross-component signal so creating a template from anywhere (e.g.
 * Home.tsx's "设为模板" button) immediately refreshes the top
 * `AutoProcessTemplateBar` chip list too (spec 五/七: "新模板立即出现在全站顶部
 * 自动模板列表中"), without having to lift template state into a shared
 * store just for this one notification.
 */
export const TEMPLATE_LIST_CHANGED_EVENT = 'apt:template-list-changed'

export function notifyTemplateListChanged(): void {
  window.dispatchEvent(new Event(TEMPLATE_LIST_CHANGED_EVENT))
}
